import React, { Component } from "react";
import {
  Form,
  Input,
  Table,
  Modal,
  // Space,
  // Radio,
  // Checkbox,
  // Tabs,
  // Popconfirm,
} from "antd";
// import moment from "moment";
// import { PlusCircleOutlined } from "@ant-design/icons";
import Api from "../../services/ServiceApi";
import Cookies from "js-cookie";
// const { TabPane } = Tabs;
class Configuration extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      language: [],
      language_data: [],
      language_name: [],
      data_table: {},
      data_list: {} , 
      file_name: [],
      size: "large",
      visible: false,
      form: {},
      columns: [],
      statustable: false,
      btnname: "",
      master_data: [],
      data_edit: {},
    };
  }
  async componentDidMount() {
    this.displaypage();
  }

  displaypage = async () => {
    const data_language = await Api.post("master_language_detail_get", {
      company_id: parseInt(Cookies.get("companyid")),
      page_id: 1,
    });
    const setcolum = [];
    var filename = [];
    var obj1 = {};
    var obj2 = [];
    var setindex = 0;
    const master_language = data_language.data.data.masteR_LANGUAGE;
    const detail_language =
      data_language.data.data.masteR_LANGUAGE_DETAIL[0].file_json;
    setcolum.push({
      title: "Field",
      dataIndex: "file_name",
      key: "",
    });
    for (let i = 0; i < master_language.length; i++) {
      setcolum.push({
        title: master_language[i].name_long,
        dataIndex: master_language[i].name_short.toLowerCase(),
        key: master_language[i].name_short.toLowerCase(),
      });
      obj1[master_language[i].name_short.toLowerCase()] = "";
    }
    for (const [key, value] of Object.entries(
      JSON.parse(detail_language)["en"]
    )) {
      filename.push({ file_name: `${key}` });
      obj2.push(obj1);
    }
    for (const [key, value] of Object.entries(obj2[0])) {
      for (const [index, data] of Object.entries(
        JSON.parse(detail_language)[`${key}`]
      )) {
        obj2[setindex] = {
          ...obj2[setindex],
          ...filename[setindex],
          [`${key}`]: `${data}`,
        };
        setindex = setindex + 1;
      }
      setindex = 0;
    }
    setcolum.push({
      title: "Action",
      dataIndex: "",
      key: "",
      render: (item) => (
        <>
          <a
            className="font-thai-sb fs-18 text-underline"
            style={{ color: "#6864FF" }}
            onClick={() => this.handleEdit(item)}
          >
            Edit
          </a>
        </>
      ),
    });
    this.setState({
      columns: setcolum,
      data_table: obj2,
      data_list: obj2 , 
      statustable: true,
      language: master_language,
      btnname: "Add File",
      master_data: JSON.parse(detail_language),
    });
  };
  handleInputChange = (event) => {
    var name = event.target.name;
    var value = event.target.value;
    var form = this.state.form;

    form[name] = value;
    this.setState(form);
  };
  handleSubmit = async () => {
    const { language, master_data, form } = this.state;

    if (this.state.btnname === "Add File") {
      for (let i = 0; i < language.length; i++) {
        master_data[[language[i].name_short.toLowerCase()]] = {
          ...master_data[[language[i].name_short.toLowerCase()]],
          [form["file_name"]]:
            form[language[i].name_short.toLowerCase()] === undefined
              ? ""
              : form[language[i].name_short.toLowerCase()],
        };
      }
      var dataset = {
        company_id: Cookies.get("companyid"),
        page_id: "1",
        language_id: "1",
        file_json: master_data,
        page: "",
        is_active: "1",
        effective_date: "1477-08-05",
        expire_date: "",
        create_date: "",
        create_by: "",
        update_date: "",
        update_by: "",
        i_mode: "U",
      };
      const Update_data = await Api.post(
        "master_language_detail_update",
        dataset
      );

      if (Update_data.data.result.code === "P") {
        this.setState({
          data_table: [],
          data_list: [] , 
          visible: false,
        });
        setTimeout(() => {
          this.displaypage();
          window.location.reload();
        }, 200);
      } else {
      }
    } else {
      for (let i = 0; i < language.length; i++) {
        master_data[[language[i].name_short.toLowerCase()]] = {
          ...master_data[[language[i].name_short.toLowerCase()]],
          [form["file_name"] === undefined
            ? this.state.data_edit["file_name"]
            : form["file_name"]]:
            form[language[i].name_short.toLowerCase()] === undefined
              ? this.state.data_edit[language[i].name_short.toLowerCase()]
              : form[language[i].name_short.toLowerCase()],
        };
      }
      var dataset = {
        company_id: Cookies.get("companyid"),
        page_id: "1",
        language_id: "1",
        file_json: master_data,
        page: "",
        is_active: "1",
        effective_date: "1477-08-05",
        expire_date: "",
        create_date: "",
        create_by: "",
        update_date: "",
        update_by: "",
        i_mode: "U",
      };
      const Update_data = await Api.post(
        "master_language_detail_update",
        dataset
      );
        console.log(Update_data.data.result.code);
      if (Update_data.data.result.code === "P") {
        this.setState({
          data_table: [],
          data_list: [], 
          visible: false,
        });
        setTimeout(() => {
          this.displaypage();
        }, 200);
      } else {
      }
    }
  };
  handleEdit = async (data) => {
    const { language, master_data, form, data_edit } = this.state;
    console.log(master_data);
    data_edit["file_name"] = data["file_name"];
    for (let i = 0; i < language.length; i++) {
      data_edit[language[i].name_short.toLowerCase()] =
        data[language[i].name_short.toLowerCase()];
    }
    this.setState({
      visible: true,
      btnname: "Edit File",
    });
    setTimeout(() => {
      this.formRef.current.setFieldsValue({
        ...data,
      });
    }, 100);
  };

  async SearchInput(value) {
    console.log(value);

    const filterData = this.state.data_table.filter(o =>
      Object.keys(o).some(k =>
          String(o[k])
              .toLowerCase()
              .includes(value.toLowerCase())
      )
  );
  this.setState({
    data_list :filterData
  })
  }
  rensderModal() {
    const { language } = this.state;
    return (
      <Modal
        title={this.state.btnname}
        centered
        visible={this.state.visible}
        footer={null}
        closable={false}
        width={700}
      >
        <Form
          layout="vertical"
          ref={this.formRef}
          onFinish={(values) => console.log(values)}
        >
          <div className="row">
            <div className="col-6">
              <Form.Item
                name="file_name"
                label="Field Name"
                rules={[
                  {
                    required: true,
                    message: "Please input the Field Name!",
                  },
                ]}
              >
                {this.state.btnname === "Edit File" ? (
                  <Input
                    name="file_name"
                    onChange={this.handleInputChange}
                    disabled
                  />
                ) : (
                  <Input name="file_name" onChange={this.handleInputChange} />
                )}
              </Form.Item>
            </div>
            <div className="col-6"></div>
            {language.map((value, key) => {
              return (
                <div className="col-4" key={key}>
                  <Form.Item
                    name={value.name_short.toLowerCase()}
                    label={value.name_long}
                  >
                    <Input
                      type="textarea"
                      name={value.name_short.toLowerCase()}
                      onChange={this.handleInputChange}
                    />
                  </Form.Item>
                </div>
              );
            })}
          </div>
        </Form>
        <div className="mt-4 text-center">
          <button
            type="reset"
            className="btn btn-secondary"
            onClick={() =>
              this.setState({ visible: false, form: {}, data_edit: {} }) +
              this.formRef.current.resetFields()
            }
          >
            Close
          </button>
          {console.log(this.state.data_edit["file_name"])}
          {(this.state.form["file_name"] === undefined ||
            this.state.form["file_name"] === "") &&
          this.state.data_edit["file_name"] === undefined ? (
            <button type="reset" className="btn btn-secondary" disabled>
              {this.state.btnname}
            </button>
          ) : (
            <button
              className="btn btn-success"
              style={{
                color: "#fff",
                backgroundColor: "#28a745",
                borderColor: "#28a745",
              }}
              onClick={this.handleSubmit}
            >
              {this.state.btnname}
            </button>
          )}
        </div>
      </Modal>
    );
  }
  render() {
    const { columns } = this.state;
    return (
      <div>
        <h3 className="font-mont-sb fs-18 c-blue">Configuration Translate</h3>
        <hr />
        <div>
        <Input.Search
          placeholder="Please Insert"
          onSearch={(value) => this.SearchInput(value)}
          style={{ width: "300px", marginLeft: "10px" }}
          enterButton
        />
          <button
            className="btn btn-success"
            style={{
              color: "#fff",
              backgroundColor: "#28a745",
              borderColor: "#28a745",
              float: "right",
            }}
            onClick={() =>
              this.setState({ visible: true, btnname: "Add Field" })
            }
          >
            Add Field
          </button>
          {this.state.statustable ? (
            <Table columns={columns} dataSource={this.state.data_list} />
          ) : null}
        </div>
        {this.rensderModal()}
      </div>
    );
  }
}
export default Configuration;
